export interface IPartyRelationShipAttributeValue {
  valueString: string;
  valueDate: string;
  valueNumber: number;
  isLoaded: boolean;
}

export interface IPartyRelationShipAttributes {
  debtAmount: IPartyRelationShipAttributeValue;
  creditLimit: IPartyRelationShipAttributeValue;
}

export interface IPartyRelationship {
  id: string;
  status: string;
  profile: object;
  attributes: IPartyRelationShipAttributes;
}



export interface IPartner {
  partyId: string;
  partnerType: string;
  direction: string;
  status: string;
  name: string;

  parentRelationship: IPartyRelationship;
  childRelationship: IPartyRelationship;
}

export const emptyPartner: IPartner = {
  partyId: '',
  partnerType: '',
  direction: '',
  status: '',
  name: '',
  parentRelationship: null,
  childRelationship: null
};

